export const config = {
    api_url: "https://car-go-server.herokuapp.com",
    api_key: process.env.REACT_APP_API_KEY as string
};
